

export default {
  name: "navBar",
  components: {},
  props: {

  },
  methods: {
    close() {
      this.$emit('close');
    },
    getRouter(path) {
      const locale = this.$i18n.locale;
      const pre = (locale == 'en' ? '/en' : '');
      return pre + path;
    }
  }
}
